var map = {
	"./__automotive.de": [
		734,
		734
	],
	"./__automotive.de.json": [
		734,
		734
	],
	"./about": [
		939,
		939
	],
	"./about.de": [
		252,
		252
	],
	"./about.de.json": [
		252,
		252
	],
	"./about.json": [
		939,
		939
	],
	"./automotive": [
		127,
		127
	],
	"./automotive.de": [
		856,
		856
	],
	"./automotive.de.json": [
		856,
		856
	],
	"./automotive.json": [
		127,
		127
	],
	"./main": [
		899,
		899
	],
	"./main.de": [
		284,
		284
	],
	"./main.de.json": [
		284,
		284
	],
	"./main.json": [
		899,
		899
	],
	"./odoo-solutions": [
		382,
		382
	],
	"./odoo-solutions.de": [
		607,
		607
	],
	"./odoo-solutions.de.json": [
		607,
		607
	],
	"./odoo-solutions.json": [
		382,
		382
	],
	"./products": [
		554,
		554
	],
	"./products.de": [
		3,
		3
	],
	"./products.de.json": [
		3,
		3
	],
	"./products.json": [
		554,
		554
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 487;
module.exports = webpackAsyncContext;